import React, {Component, Fragment} from 'react';
import {Input} from "reactstrap";
import classNames from "classnames";
import uuidv4 from 'uuid/v4';
import './OuestionEdit.scss'
import CustomForm from "../../../shared/components/form/CustomForm";
import {questionAnswerConfig} from "../../../shared/components/form/TestTemplatesConfig";
import Checkbox from "../../../shared/forms/Checkbox";
import UploadQuestionPhoto from './UploadQuestionPhoto';

class QuestionEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      id: this.props.initialValues ? this.props.initialValues.id : uuidv4(),
      title: this.props.initialValues ? this.props.initialValues.title : '',
      questionDuration: this.props.initialValues ? this.props.initialValues.questionDuration : '',
      answers: this.props.initialValues ? this.props.initialValues.answers : [],
      isSubmitted: false,
      isAddingAnswer: false,
      isEditingAnswer: null,
      isTrueFalseQuestion: false,
      isTrueFalseAnswer: false,
      isMultiple: this.props.initialValues ? this.props.initialValues.isMultiple : false,
      photo: this.props.initialValues ? this.props.initialValues.photo : null,
      isSubjective: this.props.initialValues ? this.props.initialValues.isSubjective : false,
      maxScore: this.props.initialValues ? this.props.initialValues.maxScore : '',
      answerLines: this.props.initialValues ? this.props.initialValues.answerLines || 1 : 1,
      answerExplanation: this.props.initialValues ? this.props.initialValues.answerExplanation || '' : ''
    }
  }

  get isInvalid() {
    return !this.state.title && this.state.isSubmitted
  }

  onChange(val) {
    this.setState({
      title: val
    })
  }

  onDurationChange(val) {
    this.setState({
      questionDuration: val
    })
  }

  openAddQuestionForm() {
    this.setState({
      isAddingAnswer: true
    })
  }

  closeAddQuestionsForm() {
    this.setState({
      isAddingAnswer: false
    })
  }

  addAnswer(form) {
    this.setState({
      answers: [...this.state.answers, {...form, id: uuidv4()}],
      isAddingAnswer: false
    })
  }

  setEditAnswer(answer) {
    this.setState({
      isEditingAnswer: answer
    })
  }

  editAnswer(form) {
    this.setState({
      isEditingAnswer: null,
      answers: this.state.answers.map(answer => answer.id === this.state.isEditingAnswer.id ? {
        ...answer,
        ...form
      } : answer)
    })
  }

  onPhotoUpload(data) {
    this.setState({
      photo: data.questionPhotoUrl
    });
  }

  onTrueFalseChange(e) {
    this.setState({
      isTrueFalseQuestion: e.target.checked,
      isSubjective: false,
      isMultiple: false,
    })
  }

  onSubjectiveChange(e) {
    this.setState({
      isTrueFalseQuestion: false,
      isSubjective: e.target.checked,
      isMultiple: false
    })
  }

  onMultipleChange(e) {
    this.setState({
      isTrueFalseQuestion: false,
      isSubjective: false,
      isMultiple: e.target.checked
    })
  }

  onTrueFalseAnswerChange(e) {
    this.setState({
      isTrueFalseAnswer: e.target.checked
    })
  }

  onMaxScoreChange(val) {
    this.setState({
      maxScore: val
    })
  }

  onAnswerLinesChange(val) {
    this.setState({
      answerLines: val
    })
  }

  onAnswerExplanationChange(val) {
    this.setState({
      answerExplanation: val
    })
  }

  saveQuestion() {
    if (!this.isInvalid && this.state.answers.length && this.state.answers.some(a => a.isCorrect) && !this.state.isTrueFalseQuestion && !this.state.isSubjective) {
      const correctAnswersNum = this.state.answers
        .filter(a => a.isCorrect)
        .reduce((answer) => answer + 1, 0);

      this.props.addQuestion({
        title: this.state.title,
        questionDuration: this.state.questionDuration,
        photo: this.state.photo,
        isMultiple: this.state.isMultiple || correctAnswersNum > 1,
        isSubjective: this.state.isSubjective,
        maxScore: this.state.maxScore,
        answerExplanation: this.state.answerExplanation,
        answers: this.state.answers,
        id: this.state.id
      })
    }
    else if (this.state.isTrueFalseQuestion) {
      let answers = [
        {
          title: 'True',
          isCorrect: this.state.isTrueFalseAnswer ? true : '',
          id: uuidv4()
        },
        {
          title: 'False',
          isCorrect: !this.state.isTrueFalseAnswer ? true : '',
          id: uuidv4()
        }
      ];

      this.props.addQuestion({
        title: this.state.title,
        questionDuration: this.state.questionDuration,
        photo: this.state.photo,
        isMultiple: false,
        isSubjective: false,
        answerExplanation: this.state.answerExplanation,
        answers: [
          ...answers,
        ],
        id: this.state.id
      })
    }
    else if (this.state.isSubjective) {
      this.props.addQuestion({
        title: this.state.title,
        questionDuration: this.state.questionDuration,
        photo: this.state.photo,
        isMultiple: false,
        isSubjective: true,
        maxScore: this.state.maxScore,
        answerLines: Math.max(1, parseInt(this.state.answerLines, 10) || 1),
        answerExplanation: this.state.answerExplanation,
        answers: [],
        id: this.state.id
      })
    }
  }

  render() {
    return (
      <div className="question-edit">
        <div className="form-group">
          <label className="title">
            Title
          </label>
          <Input
            className={classNames('form-control', {
              'is-invalid': this.isInvalid
            })}
            type="textarea"
            placeholder="Title"
            value={this.state.title}
            onChange={(e) => this.onChange(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="title">
            Time in minutes for this question
          </label>
          <input
            className={classNames('form-control')}
            type="text"
            placeholder="Time in minutes for this question"
            value={this.state.questionDuration}
            onChange={(e) => this.onDurationChange(e.target.value)}
          />
        </div>
        <div className="form-group">
          <UploadQuestionPhoto
            questionPhoto={this.props.initialValues ? this.props.initialValues.photo : null}
            testTemplateId={this.props.testTemplateId}
            onUpdatePhoto={(data) => this.onPhotoUpload(data)}
          />
        </div>
        <div>
          <Checkbox checked={this.state.isTrueFalseQuestion} onChange={e => this.onTrueFalseChange(e)}
                      label="True / False question"/>

          <Checkbox checked={this.state.isSubjective} onChange={e => this.onSubjectiveChange(e)}
                      label="Subjective Question"/>

          <Checkbox checked={this.state.isMultiple} onChange={e => this.onMultipleChange(e)}
                    label="Select all that apply question"/>
        </div>

        {this.state.isTrueFalseQuestion &&
          <Checkbox checked={this.state.isTrueFalseAnswer} onChange={e => this.onTrueFalseAnswerChange(e)}
                      label="The correct answer is true"/>
        }

        {this.state.isSubjective &&
          <Fragment>
            <div className="form-group">
              <label className="title">
                Maximum Score
              </label>
              <input
                className={classNames('form-control')}
                type="number"
                placeholder="Maximum Score"
                value={this.state.maxScore}
                onChange={(e) => this.onMaxScoreChange(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="title">
                Answer lines
              </label>
              <input
                className={classNames('form-control')}
                type="number"
                min="1"
                placeholder="Number of answer lines"
                value={this.state.answerLines}
                onChange={(e) => this.onAnswerLinesChange(e.target.value)}
              />
            </div>
          </Fragment>
        }

        <div className="form-group">
          <label className="title">
            Answer explanation
          </label>
          <Input
            type="textarea"
            placeholder="Shown when answer correctness is revealed"
            value={this.state.answerExplanation}
            onChange={(e) => this.onAnswerExplanationChange(e.target.value)}
          />
        </div>

        {!this.state.isTrueFalseQuestion && !this.state.isSubjective &&
          <Fragment>
            <div className="title">Answers</div>
            {this.state.answers.map(answer => (
              <div className="answer" key={answer.id}>
                <div className="answer-content">
                  <div>{answer.title}</div>
                  <div
                    className={classNames('answer-correct', {incorrect: !answer.isCorrect})}>{answer.isCorrect ? 'Correct' : 'Incorrect'}</div>
                </div>
                <div className="answer-action">
                  <button className="button small secondary" onClick={() => this.setEditAnswer(answer)}>
                    <i className="fa fa-edit"/>
                    Edit
                  </button>
                </div>
              </div>
            ))}
          </Fragment>
        }
        {this.state.isAddingAnswer && !this.state.isTrueFalseQuestion && (
          <div className="add-answer-form">
            <div className="title">Add answer</div>
            <div className="close-form" onClick={() => this.closeAddQuestionsForm()}>
              <i className="fa fa-close"/>
            </div>
            <CustomForm config={questionAnswerConfig} saveLabel="Save" saveSmall={true}
                        onSubmit={(form) => this.addAnswer(form)}/>
          </div>
        )}
        {this.state.isEditingAnswer && !this.state.isTrueFalseQuestion && (
          <div className="add-answer-form">
            <div className="title">Edit answer</div>
            <div className="close-form" onClick={() => this.closeAddQuestionsForm()}>
              <i className="fa fa-close"/>
            </div>
            <CustomForm config={questionAnswerConfig} initialValues={this.state.isEditingAnswer} saveLabel="Save"
                        saveSmall={true} onSubmit={(form) => this.editAnswer(form)}/>
          </div>
        )}
        {!this.state.isAddingAnswer && !this.state.isEditingAnswer && (
          <div className="text-right">
            {!this.state.isTrueFalseQuestion && !this.state.isSubjective &&
              <button style={{marginRight: '20px'}} className="button small primary"
                    onClick={() => this.openAddQuestionForm()}>
                <i className="fa fa-plus"/>
                Add answer
              </button>
            }
            <button className="button small primary" onClick={() => this.saveQuestion()}
                    disabled={!this.state.title || (!this.state.isTrueFalseQuestion && !this.state.isSubjective && (!this.state.answers.length || !this.state.answers.some(a => a.isCorrect)))}>
              <i className="fa fa-save"/>
              Save question
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default QuestionEdit
